<template>
  <v-dialog v-model="dialog" max-width="500px" @click:outside="$emit('close')">
    <v-card>
      <v-card-title>Job Complete Message </v-card-title>
      <v-card-text>
        <v-textarea
          hide-details
          v-model="message"
          outlined
          row-height="20px"
          rows="8"
        >
        </v-textarea>
      </v-card-text>
      <v-card-actions class="pb-5 pr-6">
        <v-spacer />
        <v-btn color="error" outlined width="150" @click="$emit('close')">
          CLOSE
        </v-btn>
        <v-btn depressed class="success" width="150" @click="send">
          SUBMIT
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { formatMessageText, getDate } from "../../assets/js/common";
import { functions, firebaseConfig } from "../../assets/js/firebase";
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
    disposition_date: {
      type: String,
      default: "",
    },
    form: {},
  },
  data() {
    return {
      message: "",
      subject: "",
      dialog: true,
    };
  },
  computed: {
    templates() {
      return this.$store.getters.templates;
    },
  },
  methods: {
    async send() {
      const vm = this;
      vm.alert = false;
      let { id } = vm.$route.params;
      let { message, disposition_date, subject } = vm;
      if (message === "") {
        vm.$root.alert("Message is required");
        return;
      }
      vm.$root.loader = true;
      try {
        let updated_at = getDate();
        let { data } = await functions.httpsCallable("jobComplete")({
          id,
          message: vm.message,
          disposition_date,
          updated_at,
          subject,
        });
        vm.$root.loader = false;
        let { status, message } = data;
        vm.$root.alert(message);
        vm.$emit("close");
        if (status) {
          vm.$router.replace("/jobs");
        }
      } catch (e) {
        vm.$root.loader = false;
        vm.$root.alert(e.message);
      }
    },
    async format() {
      const vm = this;
      try {
        vm.$loader.show();
        let { templates, item } = vm;
        let template = null;
        templates.forEach((doc) => {
          if (doc.id === "job-complete") {
            template = doc;
          }
        });
        let { job_number, template_name, fields } = item;
        fields.Job_Type = template_name;
        fields.Job_Number = job_number;
        let { id } = vm.$route.params;
        let url = `https://${firebaseConfig.authDomain}/contract/${id}`;
        let { data } = await functions.httpsCallable("shortenUrl")({ url });
        vm.$loader.hide();
        if (!data.status) {
          vm.$alert.show(data.message);
          vm.dialog = false;
          return;
        } else {
          fields.contract = data.data;
          let { message, subject } = template;
          console.log(message);
          vm.message = formatMessageText({ message, fields });
          vm.subject = subject;
        }
      } catch (error) {
        vm.$loader.hide();
        vm.$alert.show(error.message);
      }
    },
  },
  mounted() {
    this.format();
  },
};
</script>

<style></style>
